import { render, staticRenderFns } from "./BuscompanyDetails.vue?vue&type=template&id=13881b68&scoped=true&"
import script from "./BuscompanyDetails.vue?vue&type=script&lang=js&"
export * from "./BuscompanyDetails.vue?vue&type=script&lang=js&"
import style0 from "./BuscompanyDetails.vue?vue&type=style&index=0&id=13881b68&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13881b68",
  null
  
)

export default component.exports